import { FacebookLogo } from "@phosphor-icons/react";
import { LogoMark } from "@/components/Logo";
import { SITE, SERVICES } from "@/constants/site";

export const Footer = () => (
  <footer className="bg-forest-deep text-white/70 py-16" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-5">
        <div className="flex items-center gap-2.5">
          <LogoMark className="w-9 h-9" dark />
          <span className="font-serif text-lg font-semibold text-white">{SITE.brand}</span>
        </div>
        <p className="mt-5 text-sm leading-relaxed max-w-sm">
          Independent advisory for insurance and loans. We compare, you choose — and we stay
          with you all the way to claim and disbursal.
        </p>
        <p className="mt-6 text-xs text-white/40 leading-relaxed max-w-sm">
          Insurance is the subject matter of solicitation. Loans are arranged through partner
          banks &amp; NBFCs and are subject to their credit approval.
        </p>
        <a href={SITE.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link"
          className="mt-6 inline-flex items-center gap-2.5 text-sm font-semibold text-white/80 hover:text-mint-soft transition-colors duration-300">
          <span className="w-9 h-9 rounded-full bg-white/10 border border-white/10 flex items-center justify-center">
            <FacebookLogo size={18} weight="fill" />
          </span>
          Follow us on Facebook
        </a>
      </div>
      <div className="md:col-span-4">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-mint-soft">Services</p>
        <ul className="mt-5 flex flex-col gap-2.5 text-sm">
          {SERVICES.map((s) => (
            <li key={s}><a href="#services" className="hover:text-white transition-colors duration-300">{s}</a></li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-mint-soft">Reach us</p>
        <ul className="mt-5 flex flex-col gap-2.5 text-sm">
          <li><a href={`tel:${SITE.phoneHref}`} className="hover:text-white transition-colors duration-300">{SITE.phoneDisplay}</a></li>
          <li><a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors duration-300">{SITE.email}</a></li>
          <li>{SITE.address}</li>
          <li><a href="/admin" data-testid="footer-admin-link" className="hover:text-white transition-colors duration-300">Advisor Login</a></li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-6 md:px-12 mt-14 pt-8 border-t border-white/10 text-xs text-white/40 flex flex-wrap gap-4 justify-between">
      <span>© {new Date().getFullYear()} {SITE.brand}. All rights reserved.</span>
      <span>{SITE.tagline}</span>
    </div>
  </footer>
);
